import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.6967 2.6967C4.10322 1.29018 6.01088 0.5 8 0.5C9.98912 0.5 11.8968 1.29018 13.3033 2.6967C14.7098 4.10322 15.5 6.01088 15.5 8C15.5 8.98491 15.306 9.96018 14.9291 10.8701C14.5522 11.7801 13.9997 12.6069 13.3033 13.3033C12.6069 13.9997 11.7801 14.5522 10.8701 14.9291C9.96018 15.306 8.98491 15.5 8 15.5C7.01509 15.5 6.03982 15.306 5.12987 14.9291C4.21993 14.5522 3.39314 13.9997 2.6967 13.3033C2.00026 12.6069 1.44781 11.7801 1.0709 10.8701C0.693993 9.96018 0.5 8.98491 0.5 8C0.5 6.01088 1.29018 4.10322 2.6967 2.6967ZM5.375 5.375C5.66789 5.08211 6.14277 5.08211 6.43566 5.375L8 6.93934L9.56434 5.375C9.85723 5.08211 10.3321 5.08211 10.625 5.375C10.9179 5.66789 10.9179 6.14277 10.625 6.43566L9.06066 8L10.625 9.56434C10.9179 9.85723 10.9179 10.3321 10.625 10.625C10.3321 10.9179 9.85723 10.9179 9.56434 10.625L8 9.06066L6.43566 10.625C6.14277 10.9179 5.66789 10.9179 5.375 10.625C5.08211 10.3321 5.08211 9.85723 5.375 9.56434L6.93934 8L5.375 6.43566C5.08211 6.14277 5.08211 5.66789 5.375 5.375Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}